<template><div>FAQ</div></template>
<script>
  export default {
    name: 'StartpageFaq',
  }
</script>
